(function() {
    if (customElements.get('goe-separation-lines') === undefined) {
        // @todo stefi tweak animation
        // auf startseite zu finden
        // showcase url (dev ohne build) https://go-e.local/de-at/showcase/build/components/goe/separation-lines.html
        const template = document.createElement('template');
        template.innerHTML = `
        <style>
        @keyframes segment {
            0% {
                transform: scaleX(var(--segement-scale-from)) translateX(var(--segement-translate-from));
                background: var(--segment-color-from);
            }
            50% {
                transform: scaleX(var(--segement-scale-to)) translateX(var(--segement-translate-to));
                background: var(--segment-color-to);
            }
            100% {
                transform: scaleX(var(--segement-scale-from)) translateX(var(--segement-translate-from));
                background: var(--segment-color-from);
            }
        }
        @keyframes line {
            0% {
                transform: translateX(var(--line-translate-from));            
            }
            50% {
                transform: translateX(var(--line-translate-to));
            }
            100% {
                transform: translateX(var(--line-translate-from));            
            }
        }
        :host {
            --segment-height: 3px;
            --segment-width: 100%;
            --segment-color-from: var(--color-blue, rgb(0, 110, 184));
            --segment-color-to: var(--color-dark-blue, rgb(0, 52, 112));
            --line-height: 20px;
            --segement-scale-from: 1;
            --segement-scale-to: .5;
            --segement-translate-from: 0;
            --segement-translate-to: 25%;
            --segment-animation-duration: 6s;
            --segment-animation-delay: 0s;
            --line-animation-duration: 5s;
            --line-animation-delay: 0s;
            --line-translate-from: 0;
            --line-translate-to: -25%;
            display: flex;
            flex-direction: column;
            gap: calc(var(--line-height) - var(--segment-height));
            overflow: hidden;
        }
        .line {
            position: relative;
            height: var(--segment-height);
            animation: line var(--line-animation-duration) ease var(--line-animation-delay) 1 forwards;
            animation-fill-mode: both;      
        }
        .segment {
            height: var(--segment-height);
            width: var(--segment-width);
            background: var(--segment-color-from);
            position: absolute;
            top: 0;
            animation: segment var(--segment-animation-duration) ease var(--segment-animation-delay) 1 forwards;
            animation-fill-mode: both;
        }
        /*.line.start-animation  {
            animation: line var(--line-animation-duration) ease var(--line-animation-delay) 1 forwards;
            animation-fill-mode: both;      
        }
        .line.start-animation .segment {
            animation: segment var(--segment-animation-duration) ease var(--segment-animation-delay) 1 forwards;
            animation-fill-mode: both;
        }*/
        [part="line-1-start"] {
            left: -60%;
        }
        [part="line-1-end"] { 
            right: -60%;
        }
        [part="line-2"] {
            --segment-animation-delay: .5s;
            --line-animation-delay: .25s;
            --line-translate-to: 10%;
        }
        [part="line-2-start"] {
            --segement-translate-to: -35%;      
            left: -45%;  
        }
        [part="line-2-end"] {
            --segement-translate-to: -85%;     
            right: -75%;   
        }
        [part="line-3"] {
            --segment-animation-delay: 1s;
            --line-animation-delay: .5s;
            --line-translate-to: 10%;
        }
        [part="line-3-start"] {
            --segement-translate-to: -95%;   
            left: -85%
        }
        [part="line-3-end"] {
            --segement-translate-to: -35%;    
            --segement-scale-to: 1.15; 
            right: -25%        
        }
        </style>
        <div class="line" part="line-1"><div part="line-1-start" class="segment start"></div><div part="line-1-end" class="segment end"></div></div>
        <div class="line" part="line-2"><div part="line-2-start" class="segment start"></div><div part="line-2-end" class="segment end"></div></div>
        <div class="line" part="line-3"><div part="line-3-start" class="segment start"></div><div part="line-3-end" class="segment end"></div></div>
        `;
        customElements.define('goe-separation-lines', class extends HTMLElement {
            constructor() {
                super();
                this.attachShadow({mode: "open"}).appendChild(template.content.cloneNode(true));
            }
        });
    }
})();